import { AdditionalLayoutFileType, ExportType, LayoutFileType, LayoutFolderType } from "@medapro-types/Exports/export-enum";

const officeExportTypeOptions: ExportType[] = [ExportType.Excel, ExportType.Text, ExportType.XML, ExportType.JSON];
const bmeCatExportTypeOptions: ExportType[] = [ExportType.BMEcat, ExportType.BMEcat2005, ExportType.BMEcatETIM2005];
const tradeProExportTypeOptions: ExportType[] = [ExportType.TradeProNext];
const fastPageExportTypeOptions: ExportType[] = [ExportType.FastPage];
const sapAribaExporTypeOptions: ExportType[] = [ExportType.Ariba];

export const isOfficeExportType = (exportType: ExportType) => {
  return officeExportTypeOptions.includes(exportType);
};
export const isBMEcatExportType = (exportType: ExportType) => {
  return bmeCatExportTypeOptions.includes(exportType);
};
export const isTradeProExportType = (exportType: ExportType) => {
  return tradeProExportTypeOptions.includes(exportType);
};
export const isFastPageExportType = (exportType: ExportType) => {
  return fastPageExportTypeOptions.includes(exportType);
};
export const isAribaExportType = (exportType: ExportType) => {
  return sapAribaExporTypeOptions.includes(exportType);
};

export function getTargetSystem(exportType: ExportType): string | null {
  switch (true) {
    case isOfficeExportType(exportType):
      return "Office";
    case isBMEcatExportType(exportType):
      return "BMEcatG4";
    case isTradeProExportType(exportType):
      return "TradePro";
    case isFastPageExportType(exportType):
      return "FastPage";
    case isAribaExportType(exportType):
      return "Ariba";
    default:
      return null;
  }
}
export function isArticleDataType(projectType: LayoutFileType | LayoutFolderType | AdditionalLayoutFileType | null): boolean {
  return projectType === LayoutFileType.List || projectType === LayoutFileType.Label || projectType === LayoutFileType.Card;
}
